<ng-container *ngIf="!hideMetadata">
  <div nz-row class="query-metadata-wrapper" [nzGutter]="[16, 16]">
    <div nz-col nzSpan="6">
      <div class="nfl-form-label">Query Id</div>
      <span>{{ queryRecord.queryId }}</span>
    </div>
    <div nz-col nzSpan="5">
      <div class="nfl-form-label">Query Name</div>
      <p nz-typography nzEllipsis [nz-tooltip]="queryRecord.name" [nzEllipsisRows]="2">{{ queryRecord.name }}</p>
    </div>
    <div nz-col nzSpan="6">
      <div class="nfl-form-label">Query Description</div>
      <p nz-typography nzEllipsis [nz-tooltip]="queryRecord.description" [nzEllipsisRows]="2">
        {{ queryRecord.description }}
      </p>
    </div>
    <div nz-col nzSpan="4">
      <div class="nfl-form-label">Query Type</div>
      <span>{{ queryRecord.type }}</span>
    </div>

    <div nz-col nzSpan="3">
      <button nz-button nz-dropdown [nzDropdownMenu]="actionMenu">
        Action(s)
        <span nz-icon class="no-data-icon" nzType="down" nzTheme="outline"></span>
      </button>
    </div>
  </div>
  <nz-divider></nz-divider>
</ng-container>

<div nz-row class="search-wrapper" *ngIf="!hideMetadata">
  <span class="nfl-form-label" nz-typography>Search</span>
  <span class="search-box">
    <nz-input-group [nzSuffix]="inputClearTpl">
      <input
        nz-input
        nzSize="default"
        placeholder="Enter the search text..."
        [(ngModel)]="searchValue"
        type="text"
        (keyup)="search()"
      />
    </nz-input-group>
    <ng-template #inputClearTpl>
      <span
        *ngIf="searchValue"
        nz-icon
        class="ant-input-clear-icon"
        nzTheme="fill"
        nzType="close-circle"
        (click)="reset()"
      ></span>
    </ng-template>
  </span>
</div>

<div class="result-table-wrapper">
  <div class="table-content">
    <nz-table
      #nzTable
      nzSize="small"
      [nzData]="rows"
      nzTableLayout="fixed"
      nzShowPagination
      nzShowSizeChanger
      [nzLoading]="isLoading"
      [nzSize]="'middle'"
      [nzTotal]="totalCount!"
      [nzOuterBordered]="true"
      [nzNoResult]="noResultTemplate"
      [nzHideOnSinglePage]="false"
      [nzVirtualItemSize]="10"
      [nzScroll]="{ x: '75rem', y: '18.75rem' }"
      #borderedTable
      nzBordered
    >
      <thead>
        <tr>
          <th
            nzCustomFilter
            *ngFor="let cell of headers; index as i"
            [nzSortOrder]="cell.sortOrder"
            [nzSortFn]="cell.sortFn"
            [nzSortDirections]="cell.sortDirections"
            [nzFilterMultiple]="cell.filterMultiple"
            [nzFilters]="cell.listOfFilter"
            [nzFilterFn]="cell.filterFn"
            [nzWidth]="cell.width ?? '18rem'"
            [nzRight]="cell.right"
            [nzLeft]="cell.left"
            class="nfl-form-label"
            appResizableColumn
          >
            {{ cell.label }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of nzTable.data">
          <td *ngFor="let cell of headers" class="text-overflow" nz-tooltip [nzTooltipTitle]="data[cell.key]">
            <ng-container
              *ngIf="
                data[cell.key] !== '' && (data[cell.key] !== null || data[cell.key] !== undefined);
                else blankCellTpl
              "
            >
              {{ data[cell.key] }}
            </ng-container>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>
</div>

<nz-dropdown-menu #menu="nzDropdownMenu">
  <div class="ant-table-filter-dropdown">
    <div class="search-box">
      <input type="text" nz-input placeholder="Search name" [(ngModel)]="searchValue" />
      <button nz-button nzSize="small" nzType="primary" (click)="search()" class="search-button">Search</button>
      <button nz-button nzSize="small" (click)="reset()">Reset</button>
    </div>
  </div>
</nz-dropdown-menu>

<ng-template #noResultTemplate let-name>
  <div>
    <span nz-icon class="no-data-icon" nzType="file-sync" nzTheme="outline"></span>
    <p>Table information is being loaded, or there are currently no records available</p>
  </div>
</ng-template>

<nz-dropdown-menu #actionMenu="nzDropdownMenu">
  <ul nz-menu>
    <li nz-menu-item (click)="downloadCSV()">Download CSV</li>
  </ul>
</nz-dropdown-menu>

<ng-template #blankCellTpl>
  <span nz-typography>--</span>
</ng-template>
